/**
 * Pick the Secondary Advisor after a Tamarac lookup returns.
 *
 * Tamarac only knows the client's usual advisor (Ben or Tiffany), and its
 * contact-details lookup can finish after the user has already chosen an
 * advisor in the create form — e.g. Lisa, who is never Tamarac's answer.
 * So Tamarac only fills a blank choice; it never replaces one.
 *
 * @param {string} current - Advisor currently selected in the form.
 * @param {string} resolved - Advisor key derived from Tamarac.
 * @returns {string}
 */
export function autoFillAdvisor(current, resolved) {
  return current || resolved || '';
}
